import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as fileManagerApi from 'api/Settings/fileManager';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';
import { openSnackbar } from 'store/reducers/snackbar';

const InitialState = {
  data: null,
  pageSize: 10,
  currentPage: 1,
  totalRecords: 0,
  column: [
    { title: 'Request Type', key: 'request_type', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 20 },
    { title: 'Format', key: 'format', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
    { title: 'Scheduled_On', key: 'created_at', type: TYPE_OF_FIELD_IN_COLUMN.DATE, width: 120 },
    { title: 'Size', key: 'size', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
    { title: 'Status', key: 'status', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
    { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
  ],
  ui: {
    loading: false,
    msg: ''
  },
  status: 'init'
};

const getFileManagerData = createAsyncThunk('fileManagerTab/getFileManagerData', async (params) => {
  const res = await fileManagerApi.getFileManagerData(params);
  return res?.data?.data;
});

const deleteFileManagerData = createAsyncThunk('fileManagerTab/deleteFileManagerData', async (params, { dispatch, rejectWithValue }) => {
  try {
    const res = await fileManagerApi.deleteFileManagerData(params);
    if (res.success) {
      dispatch(
        openSnackbar({
          open: true,
          message: res?.data?.message,
          variant: 'alert',
          alert: {
            color: 'success'
          },
          close: false
        })
      );
    }
  } catch (error) {
    dispatch(
      openSnackbar({
        open: true,
        message: error.response.data?.message,
        variant: 'alert',
        alert: {
          color: 'error'
        },
        close: false
      })
    );
    return rejectWithValue(error);
  }
});

const FileManagerSlice = createSlice({
  name: 'fileManager',
  initialState: InitialState,
  reducers: {
    resetState: () => {
      return InitialState;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    }
  },
  extraReducers: {
    [getFileManagerData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [getFileManagerData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      state.data = action.payload?.results;
      state.totalRecords = action.payload?.count;
    },
    [getFileManagerData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },
    [deleteFileManagerData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },
    [deleteFileManagerData.fulfilled]: (state) => {
      state.status = 'idle';
      state.ui.loading = false;
    },
    [deleteFileManagerData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

export const { resetState, setCurrentPage, setPageSize } = FileManagerSlice.actions;

export default FileManagerSlice.reducer;

export { getFileManagerData, deleteFileManagerData };
